import React from 'react'

import SolidCircle from '../../assets/icons/SolidCircle'

export const RateToolTipTitle = () => (
  <>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="red" />
      </span>{' '}
      <h4> : User specific rate</h4>
    </div>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="green" />
      </span>{' '}
      <h4> : Default rate</h4>
    </div>
  </>
)

export const LeaveTooltipTitle = () => (
  <>
    <p>PLB/LT/ULB/DLB/CLB</p>
    <p>PLB = Previous Leave balance</p>
    <p>LT = Leave Taken</p>
    <p>ULB = Used Leave balance</p>
    <p>DLB = Deducted Leave balance</p>
    <p>CLB = Current Leave balance</p>
  </>
)

export const OvsZTooltipTitle = () => (
  <>
    <p>Ontime vs Zoho hours</p>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="rgb(49, 164, 51)" />
      </span>{' '}
      <h4>{` : -1 < difference < 1`}</h4>
    </div>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="orange" />
      </span>{' '}
      <h4>{` : -4 < difference < 4`}</h4>
    </div>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="rgb(229, 19, 19)" />
      </span>{' '}
      <h4>{` : -4 > difference > 4`}</h4>
    </div>
  </>
)

export const MissingTimeTooltipTitle = () => (
  <>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="rgb(49, 164, 51)" />
      </span>{' '}
      <h4>{` : -1 < missing time < 1`}</h4>
    </div>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="orange" />
      </span>{' '}
      <h4>{` : -4 < missing time < 4`}</h4>
    </div>
    <div className="color-info">
      <span>
        <SolidCircle radious="10" fillColor="rgb(229, 19, 19)" />
      </span>{' '}
      <h4>{` : -4 > missing time > 4`}</h4>
    </div>
  </>
)
